
import HttpClienteToken from '../../services/HttpClientToken';

import { TipoJuicioMateriaProps } from '../../interfaces/catalogos/TipoJuicioMateriaInterface';
import { TipoJuicioProps } from '../../interfaces/catalogos/TipoJuicioInterface';

export const TiposJuicioMateria = () => {

    return new Promise<TipoJuicioMateriaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoJuicioMateria/', token)
            .then( ({ data } : { data : TipoJuicioMateriaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTiposJuicioMateria = () => {

    return new Promise<TipoJuicioMateriaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoJuicioMateria/ObtenerTiposJuicioMateria', token)
            .then( ({ data } : { data : TipoJuicioMateriaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoJuicioPorMateria = ( id: number ) => {

    return new Promise<TipoJuicioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get(`/Api/TipoJuicioMateria/ObtenerTipoJuicioPorMateria/${ id }`, token)
            .then( ({ data } : { data : TipoJuicioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoJuicioMateria = ( params: TipoJuicioMateriaProps ) => {

    return new Promise<TipoJuicioMateriaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoJuicioMateria/Actualizar', params, token)
            .then( ({ data } : { data : TipoJuicioMateriaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoJuicioMateria: 0,                 
                    idTipoJuicio: 0,
                    idMateria: 0,
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoJuicioMateria = ( params: TipoJuicioMateriaProps ) => {

    return new Promise<TipoJuicioMateriaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoJuicioMateria/Agregar', params, token)
            .then( ({ data } : { data : TipoJuicioMateriaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoJuicioMateria: 0,                 
                    idTipoJuicio: 0,
                    idMateria: 0,
                    activo: false,     
                });
            });
        }

    });

}